export default __webpack_public_path__ + "static/media/deductions.d3a21f0a.png";